import React from 'react'
import {Redirect} from 'react-router'

import Auxi from '../../hoc/Auxi'

import './Layout.css'
import Avatar from '../../assets/images/user/avatar.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { Button, Navbar, Nav } from 'react-bootstrap'
import AnsweringRuleModal from '../../components/Widgets/Modal/AnseringRuleModal'
//import Navbar from 'navbar-react'

class AppLayout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          displaySettingsMenu: "None",
          userName: 'Daniyal',
          performLogout: false,
          openVoiceMails: false,
          showAnsweringRuleModal: false,
          openIndex: false,
          openVmailSettings: false,
          openCrexendoHD: false,
          openLandingPage: false,
          displaySecondSettingsMenu: "None",
        }
    }


  toggleSettingsHandler = (event) =>{
    event.preventDefault();
    if(this.state.displaySettingsMenu === "None"){
      this.setState({displaySettingsMenu: "block"});
    }
    else {
      this.setState({displaySettingsMenu: "None"});
    }
  }

  toggleSecondSettings = (evt) => {
    evt.preventDefault();
    if(this.state.displaySecondSettingsMenu === "None"){
      this.setState({displaySecondSettingsMenu: "flex"});
    }
    else {
      this.setState({displaySecondSettingsMenu: "None"});
    }
  }

  indexHandler =(event) => {
    event.preventDefault();
    this.setState({openLandingPage: true});
  }

  voiceHandler = (evt) => {
    evt.preventDefault();
    this.setState({openVoiceMails: true});
  }

  crexendoHdHandler = (evt) => {
    evt.preventDefault();
    this.setState({openCrexendoHD: true});
  }

  vmailSettingsHandler = (evt) => {
    evt.preventDefault();
    this.setState({openVmailSettings: true});
  }

  answeringRuleHandler = () => {
    this.setState({displaySettingsMenu: "None"});
    this.setState({showAnsweringRuleModal: true});
  }

  closeAnsweringRuleModal = () => {
    this.setState({showAnsweringRuleModal: false});
  }

  render(){

    let url = decodeURIComponent(window.location.href)

    url = url.substring(
        url.lastIndexOf("?username="),
            url.length
    );

    let redirect = null;
    const indexPath = "/index" + url;
    const voiceMailPath = "/voice_messages" + url;
    const vmailSettingsPath = "/vmail_settings" + url;
    const crexendoHDPath = "/snap_hd" + url;
  
    const md5 = require('md5');

    if(this.state.openLandingPage){
      this.setState({openLandingPage: false});
      redirect = <Redirect to = {indexPath} />;
    }

    if(this.state.openVoiceMails){
      this.setState({openVoiceMails: false});
      redirect = <Redirect to = {voiceMailPath} />;
    }
    if(this.state.openCrexendoHD){
      this.setState({openCrexendoHD: false});
      redirect = <Redirect to = {crexendoHDPath} />;
    }

    if(this.state.openVmailSettings){
      this.setState({openVmailSettings: false});
      redirect = <Redirect to ={vmailSettingsPath} />;
    }

    return(
      <Auxi >
      {redirect}
      <div className = "app-layout">
          <Navbar collapseOnSelect expand="lg" className="app-navbar" variant="light" >

            <Nav.Link href="" style={{color: "black"}} onClick={this.indexHandler}><i  className="feather icon-arrow-left"> </i></Nav.Link>
            
            <Nav>
            
              <div className="">

                  {/* <a  onClick={this.toggleSettingsHandler} href="" data-toggle="dropdown">
                      <div  className="pro-head pro-head-custom">
                          <img src={this.props.ownContact? `https://www.gravatar.com/avatar/${md5((this.props.ownContact.email).toLowerCase())}.png` :Avatar} className="img-radius" />
                      </div>
                  </a> */}

              </div>
            </Nav>
          </Navbar>

          {/* <Navbar collapseOnSelect expand="lg" className="app-navbar" variant="dark"
            style={{borderTop: "1px solid lightgrey", paddingTop:"0px", paddingBottom:"0px", 
              display: this.state.displaySecondSettingsMenu}} >
            <Nav className="mr-auto">
            </Nav>
            <Nav>
            <Nav.Link href="" onClick={this.voiceHandler}>Voicemail</Nav.Link>
            <Nav.Link href="" onClick={this.indexHandler}>SMS/Chat</Nav.Link>
            </Nav>
          </Navbar> */}
          <nav className="pcoded-navbar custom-navbar-color"  style={{display: this.state.displaySecondSettingsMenu}} >
              <div className="navbar-wrapper">
                  <div className="navbar-brand header-logo bg-White">
                    <span onClick={this.toggleSecondSettings} className="nav-link cross-nav" role="button">
                      <FontAwesomeIcon icon={faTimes} />
                    </span>
                  </div>
                  <div className="navbar-content scroll-div">
                      <ul className="nav pcoded-inner-navbar">

                          <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" className="nav-item">
                              <a className="nav-link color-white" style={{marginBottom: "6px"}}>
                                  
                                  <span className="pcoded-mtext" style={{marginLeft: "37px"}}>VIP</span>
                              </a>
                          </li>
                          <hr className="hr-nav"/>

                          <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" className="nav-item">
                              <a  href="" onClick={this.indexHandler} className="nav-link color-white">
                                  <span className="pcoded-micon">
                                      <i className="feather icon-message-square"> </i>
                                  </span>
                                  <span className="pcoded-mtext">SMS/CHAT</span>
                              </a>
                          </li>
                          <hr className="hr-nav"/>

                          <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" className="nav-item">
                              <a  href="" onClick={this.voiceHandler} className="nav-link color-white">
                                  <span className="pcoded-micon">
                                      <i className="feather icon-voicemail"> </i>
                                  </span>
                                  <span className="pcoded-mtext">VOICEMAIL</span>
                              </a>
                          </li>
                          <hr className="hr-nav"/>
                          <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" className="nav-item">
                              <a  href="" onClick={this.crexendoHdHandler} className="nav-link color-white">
                                  <span className="pcoded-micon">
                                      <i className="feather icon-camera"> </i>
                                  </span>
                                  <span className="pcoded-mtext">CrexendoHD</span>
                              </a>
                          </li>
                          <hr className="hr-nav"/>

                          <li data-username="dashboard Default Ecommerce CRM Analytics Crypto Project" className="nav-item">
                              <a  href="" onClick={this.vmailSettingsHandler} className="nav-link color-white">
                                  <span className="pcoded-micon">
                                      <i className="feather icon-settings"> </i>
                                  </span>
                                  <span className="pcoded-mtext">SETTINGS</span>
                              </a>
                          </li>
                          <hr className="hr-nav"/>

                      </ul>
                  </div>
              </div>
          </nav>
          {
              this.state.session_id !== '' ?

                  <AnsweringRuleModal
                      modalIsOpen={this.state.showAnsweringRuleModal}
                      closeModal={this.closeAnsweringRuleModal}
                      authenticateHandler={this.authenticateConversationHandler}
                      type={'Authenticate'}
                      username={this.state.username}
                      password={this.state.password}
                      session_id={this.state.session_id}/>
              :
                  null
          
          }
          <div className="dropdown-menu-custom dropdown-menu-right-custom profile-notification"
            style={{display: this.state.displaySettingsMenu}}>
                <div className="pro-headw" style={{minWidth: "100px"}}>

                    <span id = "user_name">{this.props.ownContact? this.props.ownContact.first_name :this.props.display_name.split('@')[0]}</span>

                </div>
              <ul className="pro-body">

                    <li>
                        <a onClick={this.answeringRuleHandler} className="dropdown-item" >
                            <i className="feather icon-download"> </i>
                            Answering Rules
                        </a>
                    </li>

              </ul>
          </div>
        </div>
      </Auxi>
    );
  }

}

export default AppLayout;
